<template>
    <a-select :options="cateList" placeholder="请选择相册分类" v-bind="$attrs" v-model="cateValue" v-on="$listeners"/>
</template>

<script>

    import cache from "../../../../utils/cache";

    export default {
        name: "AlbumCate",
        data() {
            return {
                cateList: []
            }
        },
        computed: {
            cateValue: {
                get() {
                    return this.$attrs.value ? this.$attrs.value : undefined;
                },
                set(value) {
                    this.$emit("input", value);
                }
            }
        },
        mounted() {
            cache.v1.option.cates()
                .then(res => this.cateList = res);
        },
    };
</script>
